import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Topics from './components/Topics';
import AppSection from './components/AppSection';
import Carousel from './components/Carousel';
import Comments from './components/Comments';
import Faq from './components/Faq';
import About from './components/About';
import Cards from './components/Cards';
import Ranking from './components/Ranking';
import Contact from './components/Contact';
import Media from './components/Media';
import Index from './components/Index';
import Updates from './components/Updates';
import Footer from './components/Footer';
import AnimatedSection from './components/AnimatedSection';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Header />

      <main>
        <Hero />

        <AnimatedSection delay={100}>
          <Features />
        </AnimatedSection>

        <AnimatedSection delay={100}>
          <Topics />
        </AnimatedSection>

        <AnimatedSection delay={100}>
          <AppSection />
        </AnimatedSection>

        <AnimatedSection delay={100}>
          <Carousel />
        </AnimatedSection>

        <AnimatedSection delay={100}>
          <Comments />
        </AnimatedSection>

        <AnimatedSection delay={100}>
          <Faq />
        </AnimatedSection>

        <AnimatedSection delay={100}>
          <About />
        </AnimatedSection>

        <AnimatedSection delay={100}>
          <Cards />
        </AnimatedSection>

        <AnimatedSection delay={100}>
          <Ranking />
        </AnimatedSection>

        <AnimatedSection delay={100}>
          <Contact />
        </AnimatedSection>

        <AnimatedSection delay={100}>
          <Media />
        </AnimatedSection>

        <AnimatedSection delay={100}>
          <Index />
        </AnimatedSection>

        <AnimatedSection delay={100}>
          <Updates />
        </AnimatedSection>
      </main>

      <Footer />
    </div>
  );
}